import { render, staticRenderFns } from "./Declined.vue?vue&type=template&id=c6c877c0&scoped=true&"
import script from "./Declined.vue?vue&type=script&lang=js&"
export * from "./Declined.vue?vue&type=script&lang=js&"
import style0 from "./Declined.vue?vue&type=style&index=0&id=c6c877c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c877c0",
  null
  
)

export default component.exports